import { render, staticRenderFns } from "./AffinForm.vue?vue&type=template&id=c7b046e0"
import script from "./AffinForm.vue?vue&type=script&lang=js"
export * from "./AffinForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports